import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'vcmReplaceBaseHref'})
export class ReplaceBaseHrefPipe implements PipeTransform {

	transform(str: string, baseUrl: string): string {
		return str.replace(new RegExp('href="#', 'g'), `href="${baseUrl}#`);
	}
}